var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgArrowToRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.077 7.62499H0.888888C0.467005 7.62499 0.125 7.9328 0.125 8.31249C0.125 8.69219 0.467005 8.99999 0.888888 8.99999H12.077L6.44477 14.6323C6.17628 14.9007 6.17628 15.336 6.44477 15.6045C6.71325 15.873 7.14855 15.873 7.41704 15.6045L13.2507 9.7709C13.6057 9.41588 13.8042 8.96363 13.8463 8.49987C13.865 8.4403 13.875 8.37745 13.875 8.31249C13.875 8.24754 13.865 8.18469 13.8463 8.12512C13.8042 7.66136 13.6057 7.20911 13.2507 6.85409L7.41704 1.02046C7.14855 0.75197 6.71325 0.75197 6.44477 1.02046C6.17628 1.28894 6.17628 1.72424 6.44477 1.99273L12.077 7.62499Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToRight);
export default __webpack_public_path__ + "static/media/ArrowToRight.16b3d0dedc4c1638c504b6b6c2886f02.svg";
export { ForwardRef as ReactComponent };